import { render, staticRenderFns } from "./IconPlaceholder.vue?vue&type=template&id=65dc1c56&"
import script from "./IconPlaceholder.vue?vue&type=script&lang=js&"
export * from "./IconPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports